// returns url based on environment
export const getRedirectUrl = (origin, page = 'dashboard') => {
    let url = ''
    switch (origin) {
        case 'https://chirpqa.com':
            url = `https://dashboard.chirpqa.com/${page}/`
            break;
        case 'https://parkcheep.com':
            url = `https://stg-pa-react-app.parkcheep.com/${page}/`
            break;
        case 'https://parkchirp.com':
            url = `https://prod-pa-react-app.parkchirp.com/${page}/`
            break;
        default:
            url = `http://local.parkchirp.com:4001/${page}/`
            break;
    }
    return url
}
